var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "template-items-modal" },
    [
      _c(
        "base-modal-ex",
        {
          attrs: {
            active: _vm.active,
            "animation-in": _vm.animationIn,
            "animation-out": _vm.animationOut,
            "animation-duration": _vm.animationDuration,
            "can-cancel": false,
            "has-modal-card": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.active = $event
            },
          },
        },
        [
          _c("div", { staticClass: "model-content" }, [
            _c("div", { staticClass: "modal-card" }, [
              _c("header", { staticClass: "modal-card-head" }, [
                _c("p", { staticClass: "modal-card-title" }, [
                  _vm._v(" Select Items "),
                ]),
              ]),
              _c("section", { staticClass: "modal-card-body" }, [
                _c("div", { staticClass: "columns m-0" }, [
                  _c("div", { staticClass: "column is-one-quarter" }, [
                    _c("div", { staticClass: "field" }, [
                      _vm._v(" Template Name : "),
                      _c("strong", [_vm._v(_vm._s(_vm.selectedTemplate.name))]),
                    ]),
                  ]),
                  _c("div", { staticClass: "column" }, [
                    _c(
                      "div",
                      { staticClass: "field" },
                      [
                        _vm._v(" Tags : "),
                        _vm.selectedTagIDs.length
                          ? _vm._l(
                              _vm.tags.filter((t) =>
                                _vm.selectedTagIDs.includes(t.tagID)
                              ),
                              function (tag) {
                                return _c(
                                  "span",
                                  {
                                    key: tag.tagID,
                                    staticClass: "tag-short mr-1",
                                    style: {
                                      backgroundColor: tag.colorHex,
                                      color: _vm.getTextColor(tag.colorHex),
                                      marginBottom: "2px",
                                    },
                                  },
                                  [_vm._v(" " + _vm._s(tag.shortTag) + " ")]
                                )
                              }
                            )
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]),
                  _c("div", { staticClass: "column is-one-third" }, [
                    _c("div", { staticClass: "field" }, [
                      _c(
                        "div",
                        {
                          staticClass: "control",
                          staticStyle: { position: "relative" },
                        },
                        [
                          _c("span", {
                            staticClass:
                              "has-badge-rounded has-badge-medium has-badge-danger",
                            attrs: { "data-badge": "NEW" },
                          }),
                          _c(
                            "div",
                            {
                              ref: "tagDropdown",
                              staticClass: "dropdown",
                              class: { "is-active": _vm.tagDropdownActive },
                              staticStyle: { width: "100%" },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "dropdown-trigger",
                                  staticStyle: { width: "100%" },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "input",
                                      on: { click: _vm.toggleTagDropdown },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticStyle: { color: "#b5b5b5" } },
                                        [_vm._v("Add Tags")]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "icon is-right",
                                          staticStyle: {
                                            "pointer-events": "none",
                                            position: "absolute",
                                            right: "10px",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "mdi mdi-menu-down",
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _c("TagsDropdownMenu", {
                                attrs: {
                                  tags: _vm.tags,
                                  "selected-tags": _vm.selectedTagIDs,
                                  "is-visible": _vm.tagDropdownActive,
                                },
                                on: {
                                  "toggle-tag": _vm.toggleTag,
                                  "clear-all-tags": _vm.clearAllTags,
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]),
                  ]),
                ]),
                _vm.isLoading
                  ? _c(
                      "div",
                      { staticClass: "spinner-container" },
                      [_c("spinner")],
                      1
                    )
                  : _c("div", [
                      _c("div", { staticClass: "is-flex mt-4" }, [
                        _c("div", {}, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "pretty p-icon p-curve p-smooth p-bigger",
                            },
                            [
                              _c("input", {
                                attrs: {
                                  type: "checkbox",
                                  id: "quote-template-items-checkbox-all-items",
                                  name: "quote-template-items-checkbox-all-items",
                                },
                                domProps: { checked: _vm.areAllSelected },
                                on: { click: _vm.handleSelectAll },
                              }),
                              _c("div", { staticClass: "state p-primary" }, [
                                _c("i", { staticClass: "icon mdi mdi-check" }),
                                _c("label"),
                              ]),
                            ]
                          ),
                        ]),
                        _c("span", { staticClass: "mr-2" }, [
                          _vm._v(" Select All "),
                        ]),
                      ]),
                      _c(
                        "div",
                        { staticClass: "template-items-container" },
                        _vm._l(_vm.sortedData, function (data, index) {
                          return _c("div", { key: data.name + index }, [
                            data.items.length > 0
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "template-item-grid is-title mt-5 pt-1 pb-2 mb-2",
                                    class: `quote-item-heading-${_vm.$theme.name}`,
                                  },
                                  [
                                    _c("div", {}, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "pretty p-icon p-curve p-smooth p-bigger",
                                        },
                                        [
                                          _c("input", {
                                            attrs: {
                                              type: "checkbox",
                                              disabled: data.items.length === 0,
                                              id: "quote-template-items-checkbox-all-items",
                                              name: "quote-template-items-checkbox-all-items",
                                            },
                                            domProps: {
                                              checked: _vm.areAllItemsSelected(
                                                data.items
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleSelectAllItems(
                                                  data.items
                                                )
                                              },
                                            },
                                          }),
                                          _c(
                                            "div",
                                            { staticClass: "state p-primary" },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "icon mdi mdi-check",
                                              }),
                                              _c("label"),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _c(
                                      "div",
                                      {
                                        staticStyle: { "font-weight": "bold" },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(data.name) +
                                            " (" +
                                            _vm._s(data.length) +
                                            ")"
                                        ),
                                      ]
                                    ),
                                    data.items.length > 0
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "is-flex is-justify-content-center",
                                          },
                                          [_vm._v(" Report ")]
                                        )
                                      : _vm._e(),
                                    _c("div"),
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "div",
                              _vm._l(data.items, function (item, indexchild) {
                                return _c(
                                  "div",
                                  {
                                    key: index + indexchild,
                                    staticClass:
                                      "template-item-grid is-size-6 mb-1 ml-5",
                                    attrs: { value: item },
                                  },
                                  [
                                    _c("div", [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "pretty p-icon p-curve p-smooth p-bigger",
                                        },
                                        [
                                          _c("input", {
                                            class: true ? "is-primary" : "",
                                            attrs: {
                                              type: "checkbox",
                                              id:
                                                "quote-template-items-checkbox-child" +
                                                index +
                                                indexchild,
                                              name:
                                                "quote-template-items-checkbox-child" +
                                                index +
                                                indexchild,
                                            },
                                            domProps: {
                                              checked: _vm.isItemSelected(item),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleItemClick(item)
                                              },
                                            },
                                          }),
                                          _c(
                                            "div",
                                            { staticClass: "state p-primary" },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "icon mdi mdi-check",
                                              }),
                                              _c("label"),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _c("div", {}, [
                                      _vm._v(" " + _vm._s(item.itemDesc) + " "),
                                    ]),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "is-flex is-justify-content-center",
                                      },
                                      [
                                        item.reportOnly
                                          ? _c(
                                              "span",
                                              {
                                                directives: [
                                                  {
                                                    name: "tippy",
                                                    rawName: "v-tippy",
                                                    value: {
                                                      theme: "secondary",
                                                      enabled: true,
                                                    },
                                                    expression:
                                                      "{ theme: 'secondary', enabled: true }",
                                                  },
                                                ],
                                                staticClass:
                                                  "tag is-danger p-1 px-2 is-dark",
                                                attrs: { content: "Report" },
                                              },
                                              [_vm._v("R ")]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]
                                )
                              }),
                              0
                            ),
                          ])
                        }),
                        0
                      ),
                    ]),
              ]),
              _c(
                "footer",
                {
                  staticClass: "modal-card-foot",
                  style: `justify-content: flex-end`,
                },
                [
                  _c(
                    "button",
                    { staticClass: "button", on: { click: _vm.close } },
                    [
                      _c(
                        "span",
                        { staticClass: "material-symbols-outlined mr-1" },
                        [_vm._v("close")]
                      ),
                      _c("span", [_vm._v("Close")]),
                    ]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "button is-primary",
                      attrs: { disabled: !_vm.isTemplateSelected },
                      on: { click: _vm.handleAddTemplateItems },
                    },
                    [_vm._v("Add to Quote")]
                  ),
                ]
              ),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }